import React from "react";
import { Button, Label, Row } from "reactstrap";
import Swal from "sweetalert2";
import { postponePayment } from "./AccountAPI";
import { useUserBhphPrivileges } from "../features/settings/subFeatures/settingsTabs/userManagement/useUserPrivileges";
import useCurrentAccountStore from "./AccountStore";
import shallow from "zustand/shallow";
import InputElement from "../features/forms/components/InputElement";
import dayjs from "dayjs";

const PostponeButton = () => {
	const { acct, editAmortizations, amortizations } = useCurrentAccountStore(
		(state) => ({
			amortizations: state.amortizations,
			editAmortizations: state.editAmortizations,
			acct: state.account,
		}),
		shallow
	);
	const today = dayjs().format("YYYY-MM-DD");
	const amort = amortizations.find((item) => item.dueDate === acct.nextDueDate);

	if (!amort || dayjs(today).isAfter(dayjs(acct.nextDueDate))) {
		console.log("No amortization record found for the next due date.");
		return;
		// You can return, throw, or use a fallback here
	}

	// Compute how much is still owed:
	let balance =
		amort.int2Pay +
		amort.princ2Pay +
		(amort.salesTax || 0.0) -
		(amort.intPaid || 0.0) -
		(amort.princPaid || 0.0) -
		(amort.salesTaxPaid || 0.0);
	balance = parseFloat(balance).toFixed(2);
	balance = parseFloat(balance);
	// Remaining principal-only balance:
	const prnBalance = parseFloat(
		parseFloat(amort.princ2Pay - (amort.princPaid || 0)).toFixed(2)
	);

	const privileges = useUserBhphPrivileges();
	const p = privileges();

	const handlePostpone = () => {
		Swal.fire({
			title: "Are you sure?",
			text: "You won't be able to revert this!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Yes, postpone it!",
		}).then((result) => {
			if (result.isConfirmed) {
				postponePayment(amort.id);
			}
		});
	};

	-amort.isDeferred === false;

	return (
		<>
			<Button
				color="warning"
				disabled={!p.postponePayment}
				onClick={handlePostpone}
			>
				Postpone next payment{" "}
				<h6>{dayjs(amort.dueDate).format("MM/DD/YYYY")}</h6>
			</Button>
		</>
	);
};

export default PostponeButton;
